import { Button, message } from "antd";
import { useEffect, useState } from "react";
import StepCard from "../ui/StepCard";
import { Card, ListItem } from "./SectionTwo.default";
import CompletedStageCard from "../ui/CompletedStageCard";

// PD-02 §6.14 Management & Review — leadership review, management follow-up,
// and review of outputs, actions, findings and company progress.
const stageStepCards: Card[] = [
  {
    count: 1,
    status: "completed",
    title: "Leadership review summary",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Compile a leadership review summary of outcomes from Evaluation
          (progress indicators, program effectiveness, incident response).
        </li>
        <li>
          Share with executives and department leads via the platform.
        </li>
      </>
    ),
    backgroundColor: "#a0a0c2",
    actions: [
      {
        name: "start",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 2,
    status: "completed",
    title: "Open and overdue actions",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Review every open and overdue company action from the Actions grid.
        </li>
        <li>
          Reassign, extend or close actions as part of this review cycle.
        </li>
      </>
    ),
    backgroundColor: "#8eb1bd",
    actions: [
      {
        name: "review",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 3,
    status: "completed",
    title: "Policy and training follow-up",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Review acknowledgment coverage for published policies and remind
          overdue employees where needed.
        </li>
        <li>
          Confirm attendance and completion for scheduled trainings.
        </li>
      </>
    ),
    backgroundColor: "#bdb0ac",
    actions: [
      {
        name: "review",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
  {
    count: 4,
    status: "completed",
    title: "Key risk and progress findings",
    listTitle: "Instructions:",
    checkList: (
      <>
        <li>
          Document key risks, residual issues and progress findings for this
          review period.
        </li>
        <li>
          Set the next review date and the decisions to carry forward.
        </li>
      </>
    ),
    backgroundColor: "#7c9281",
    actions: [
      {
        name: "record",
        action: () => {
          message.info("This action is not yet available.");
        },
      },
    ],
  },
];

const completedStageList: ListItem[] = [
  {
    name: "Review Your Inputs:",
    items: [
      "Confirm the leadership summary captures the latest cycle.",
      "Confirm open-action decisions, policy/training follow-ups and findings are recorded.",
    ],
  },
  {
    name: "Submit the Management & Review Stage:",
    items: [
      "Once review is finalized, click the Submit Stage button.",
      "A confirmation popup will appear. Confirm to close this review cycle.",
    ],
  },
  {
    name: "Next Cycle:",
    items: [
      "Upon submission, you'll be redirected to the Overview page where the next wellbeing cycle starts.",
    ],
  },
];

const completedStageTitle = "Completing the Management & Review Stage";

const subTitleText = (
  <p>
    Congratulations on completing Management & Review! Follow these steps to
    finalize this stage:
  </p>
);

function SectionTwo() {
  const [submitActive, setSubmitActive] = useState(false);
  const [showCompletedStage, setShowCompletedStage] = useState(false);

  useEffect(() => {
    findUncompletedSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onSubmit() {
    setShowCompletedStage(true);
  }

  function findUncompletedSteps() {
    const uncompletedSteps = stageStepCards.filter(
      (step) => step.status !== "completed",
    );
    setSubmitActive(uncompletedSteps.length === 0);
    return uncompletedSteps;
  }

  return (
    <section className="mx-auto max-w-[1920px] px-16 py-16">
      {stageStepCards.map((card) => (
        <StepCard
          key={card.count}
          countValue={card.count}
          status={card.status}
          title={card.title}
          checkListTitle={card.listTitle}
          checkList={card.checkList}
          backgroundColor={card.backgroundColor}
          actions={card.actions}
        />
      ))}
      <div className="flex justify-center py-8">
        <Button
          disabled={!submitActive}
          className={`bg-[#ffc107] px-16 py-8 text-lg font-bold tracking-wide ${submitActive && "hover:text-white"} `}
          onClick={onSubmit}
        >
          SUBMIT
        </Button>
      </div>
      {(showCompletedStage || submitActive) && (
        <CompletedStageCard
          title={completedStageTitle}
          subTitleText={subTitleText}
          list={completedStageList}
        />
      )}
    </section>
  );
}

export default SectionTwo;
